import { action, extendObservable } from 'mobx';
import PropTypes from 'prop-types';
import { apiCall } from '../API';
import ipValidator from '../ipValidator';
import AsyncActionStore from './AsyncActionStore';
import FlagStore from './FlagStore';
import UrlBulkEditorStore from './UrlBulkEditorStore';
import BulkEditorStore from './BulkEditorStore';

export default class IpRegStore {
    static PropType = PropTypes.shape({
        saveStatus: AsyncActionStore.PropType.isRequired,
        verifyStatus: AsyncActionStore.PropType.isRequired,
        modal: FlagStore.PropType.isRequired,
        ipsBulkEditor: UrlBulkEditorStore.PropType.isRequired,
        exitConfirmationModal: FlagStore.PropType.isRequired,

        close: PropTypes.func.isRequired,
        setFromObj: PropTypes.func.isRequired,
        save: PropTypes.func.isRequired,
        verifyIpRanges: PropTypes.func.isRequired,
    });

    constructor(data = {}) {
        extendObservable(this, /** @class IpRegStore */ {
            apiSave: apiCall('/console_admin_api/ip_reg/set', { isUserAction: true }),
            saveStatus: new AsyncActionStore(),
            apiVerifyIpRanges: apiCall('/console_admin_api/ip_reg/verify_ip_ranges', { isUserAction: true }),
            verifyStatus: new AsyncActionStore(),
            modal: new FlagStore(false),
            ipsBulkEditor: new UrlBulkEditorStore({
                margin: 0,
                bulkEditorStore: new BulkEditorStore({ validator: ipValidator }),
            }),
            exitConfirmationModal: new FlagStore(false),

            get hasChanged() {
                return this.ipsBulkEditor.bulkEditorStore.hasChanged();
            },
        }, data);
    }

    close = action(() => {
        if (this.hasChanged) {
            this.exitConfirmationModal.open();
        } else {
            this.modal.close();
        }
    });

    setFromObj = action(({ ipRanges }) => {
        this.ipsBulkEditor.bulkEditorStore.setUrlPatterns(ipRanges);
    });

    toObj = () => {
        const ipRanges = this.ipsBulkEditor.bulkEditorStore.urlPatterns.map((ipRange) => ipRange.trim());

        return {
            ipRanges: ipRanges.filter((ipRange, index) => ipRange &&
                !ipRanges.some((otherIpRange, otherIndex) => otherIndex < index && otherIpRange === ipRange)),
        };
    };

    save = action(() => {
        if (this.saveStatus.isLoading) {
            return;
        }
        this.saveStatus.setLoading();
        const data = this.toObj();
        return this.apiSave(data)
            .then(action(() => {
                this.setFromObj(data);
                this.saveStatus.onSuccess();
                this.modal.close();
                return data;
            }))
            .catch((e) => {
                this.saveStatus.setFailed(e);
                throw e;
            });
    });


    verifyIpRanges = action(() => {
        if (this.verifyStatus.isLoading) {
            return;
        }
        this.verifyStatus.setBase();
        if (!this.ipsBulkEditor.bulkEditorStore.isValid()) {
            return;
        }
        this.verifyStatus.setLoading();
        return this.apiVerifyIpRanges(this.toObj())
            .then(action((data) => {
                this.verifyStatus.setBase();
                return data;
            }))
            .catch((e) => {
                this.verifyStatus.setFailed(e);
                throw e;
            });
    });
}
